/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2015, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function() {

	return {
		KEY_DELETE_MAC: 8,
		KEY_TAB: 9,
		KEY_ENTER: 13,
		KEY_CTRL: 17,
		KEY_ESCAPE: 27,
		KEY_SPACE: 32,
		KEY_END: 35,
		KEY_HOME: 36,
		KEY_LEFT: 37,
		KEY_UP: 38,
		KEY_RIGHT: 39,
		KEY_DOWN: 40,
		KEY_DELETE: 46,
		KEY_SECOND: 50,
		KEY_s: 83,
		KEY_OPEN_BRACKET: 219,
		KEY_CLOSE_BRACKET: 221,
		KEY_h: 72,
		KEY_e: 69
	};

});